import Text from '../../Text'

import * as styles from './CalendarGridCardField.module.css'

function CalendarGridCardField({ label, value }) {
  return (
    <div className={styles.CalendarGridCardField}>
      <Text isSecondary>{label}</Text>
      <Text>{value}</Text>
    </div>
  )
}

export default CalendarGridCardField
